import React from 'react';
import './Loader.css';

/**
 * Loader – Ransilu Platform's single, unified loading indicator.
 *
 * An animated equalizer/waveform (a nod to the music catalog & royalty
 * data this platform manages) rendered in the brand's primary blue, used
 * everywhere the app waits on an API response so the experience feels
 * consistent instead of a different spinner per page.
 *
 * Props:
 *   size  – 'small' | 'medium' | 'large' (default: 'medium')
 *   label – optional caption rendered below the animation
 */
function Loader({ size = 'medium', label }) {
  return (
    <div
      className={`rl-loader rl-loader--${size}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label || 'Loading'}
    >
      <div className="rl-loader__bars">
        <span className="rl-loader__bar"></span>
        <span className="rl-loader__bar"></span>
        <span className="rl-loader__bar"></span>
        <span className="rl-loader__bar"></span>
        <span className="rl-loader__bar"></span>
      </div>
      {label && <p className="rl-loader__label">{label}</p>}
    </div>
  );
}

export default Loader;
